import {useTranslation} from 'react-i18next';

import {ActivationMetaItem} from './ActivationMetaItem';

import type {FC} from 'react';

export const ActivationEtaItem: FC = () => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ActivationMetaItem
      icon="clock"
      label={t('activation.etaLabel')}
      value={t('activation.etaValue')}
    />
  );
};
